import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import TextIconCollection from '../../../Core/TextIconCollection';
import VideoTutorialTile from '../../Video/VideoTutorialTile';
import Image from '../../../Core/Image';
import { StyledContainer } from '../../SectionContainer/styles';
import { VideoTileWrapper } from '../../Video/VideoTutorialTile/styles';

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding-top: 30px;

  &.with-controls {
    padding-bottom: 50px;
  }

  &.show-overflow {
    overflow: visible;
  }

  &.app-banner-image-center {
    padding: 30px 0;
  }

  p + p {
    margin-top: 0.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding-top: 60px;
    &.app-banner-image-center {
      padding: 60px 0;
    }

    &.with-controls {
      padding-bottom: 40px;
    }
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &.app-banner-image-center {
      padding: 100px 0;
    }

    &.with-controls {
      padding-bottom: 100px;
    }
  }
`;

export const Content = styled.div`
  width: 100%;

  ${Wrapper}.with-controls {
    margin-bottom: 60px;
  }

  h2,
  h3 {
    margin-bottom: 30px;
  }

  ${Wrapper}.with-controls & {
    padding-top: 60px;
  }

  ${Wrapper}.show-overflow & {
    margin-bottom: 40px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 50%;
    padding-bottom: 0;

    ${Wrapper}.with-controls & {
      padding-top: 100px;
    }

    ${Wrapper}.show-overflow & {
      max-width: 100%;
      margin-bottom: 30px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 580px;

    ${Wrapper}.show-overflow & {
      max-width: 770px;
      margin-bottom: 50px;
    }
  }

  ${StyledContainer}.app-banner-video-section & {
    margin-bottom: 3.5rem;
    text-align: center;

    h2,
    h3 {
      margin-bottom: 1rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      h2,
      h3 {
        margin-bottom: 1.5rem;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      text-align: left;
      h2,
      h3 {
        margin-bottom: unset;
      }
    }
  }
`;

export const Features = styled.div`
  width: 100%;

  ${Wrapper}.show-overflow & {
    display: flex;
    flex-direction: column-reverse;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 380px;

    ${Wrapper}.show-overflow & {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 580px;

    ${Wrapper}.show-overflow & {
      max-width: 770px;
    }
  }

  ${StyledContainer}.app-banner-video-section & {
    max-width: none;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      max-width: 670px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      max-width: 575px;
    }

    @media only screen and (min-width: 1440px) {
      max-width: 605px;
    }
  }

  & ${VideoTileWrapper} {
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 0 0 3.5rem;
    }
  }
`;

export const IconCollection = styled(TextIconCollection)`
  padding-bottom: 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    padding-bottom: 60px;
  }
`;

export const VideoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;

  ${StyledContainer}.app-banner-video-section & {
    margin-bottom: 70px;
    justify-content: center;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      justify-content: space-between;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin-bottom: 0;
    }
  }
`;

export const FeaturedVideos = styled(VideoTutorialTile)`
  &.app-banner {
    margin: 0 0 2rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-bottom: unset;
    }
  }
`;

export const Links = styled.div`
  margin-bottom: 45px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 0;
  }
`;

export const Product = styled.div`
  align-self: center;
  max-width: 480px;

  ${Wrapper}.show-overflow & {
    margin: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-height: calc(100% - 60px);
    width: 360px;
    align-self: flex-end;
    position: absolute;
    right: 0;
    bottom: 50%;
    transform: translateY(50%);

    ${Wrapper}.show-overflow & {
      position: relative;
      top: unset;
    }
  }

  @media only screen and (min-width: 1040px) {
    width: 437px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 580px;

    ${Wrapper}.show-overflow & {
      position: absolute;
      bottom: 75px;
    }
  }

  ${StyledContainer}.app-banner-video-section & {
    max-height: 100%;
    position: relative;
    bottom: auto;
    right: auto;
    align-self: flex-start;
    transform: none;
    margin: 0 auto;

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      position: absolute;
      bottom: 50%;
      right: 0;
      align-self: flex-end;
      transform: translateY(50%);
    }
  }
`;

export const Img = styled(Image)`
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  ${Wrapper}.show-overflow & {
    max-height: 576px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${Wrapper}.show-overflow & {
      width: auto;
      height: 100%;
      max-height: 521px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${Wrapper}.show-overflow & {
      height: 100%;
      max-height: 831px;
    }
  }
`;
